import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { deletePO } from "../../../redux/ducks/project";
import { deleteAnalysis } from "../../../redux/ducks/analysis";


const DeletePO = props => {
    const [show, hide, renderModal] = useModal();
    const [d_deletePO, status, error, event] = useStatusThunk(deletePO);
    
  
    const deleteO = () => {
         d_deletePO({  projectID: props.projectID });
         window.location.reload(false);
    }

    

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete PO</button>

            {renderModal(
                <React.Fragment>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>
                    <div className="info-block">Are you sure you want to delete this Project Order? Once deleted it cannot be recovered. </div>
                    <LoadingButton loading={status == "pending"} className="button--danger" onClick={() => deleteO()}>Delete PO</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default DeletePO;